export class ChatBaloon {
  /**
   * ChatBaloon - ES6 class which uses the Intersection observer
   * to detect if any given element(targetClassName) is within the viewport when scrolling or loading the page.
   * (https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API)
   * @param {string} obj.rootMargin - Root margin (see MDN)
   * @param {number} obj.threshold - Threshold (see MDN)
   * @param {number} obj.targetClassName - The element's class name to query for in the document.
   * @param {number} obj.toggleClassName - The classname we will add to the element's classlist.
   */
  constructor({
    rootMargin = "0px",
    threshold = 1,
    targetClassName = "chatbaloon",
    toggleClassName = "is-visible"
  } = {}) {
    this.init({ rootMargin, threshold, targetClassName, toggleClassName });
  }

  /**
   * Initiates the IntersectionObserver.
   * @param rootMargin
   * @param threshold
   * @param targetClassName
   * @param toggleClassName
   */
  init({ rootMargin, threshold, targetClassName, toggleClassName }) {
    if (typeof IntersectionObserver === 'undefined') {
      return
    }
    const options = { rootMargin, threshold };
    // Add a class to the classList when element is in viewport and stop observing the element.
    const observerCallback = (entries, observer) => {
      const { 0: entry } = entries;
      const { target } = entry;
      const ratio = Math.round(entry.intersectionRatio);
      if (ratio >= threshold && !target.classList.contains(toggleClassName)) {
        target.classList.add(toggleClassName);
        observer.unobserve(target);
      }
    };

    // Find all elements with the given 'targetclassName'
    const targetElements = document.querySelectorAll(`.${targetClassName}`);
    const observer = new IntersectionObserver(observerCallback, options);
    // Observe each element
    targetElements.forEach(targetElement => observer.observe(targetElement));
  }
}
